import { environment } from './../environments/environment';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { catchError, switchMap, switchMapTo, tap } from 'rxjs/operators';
import { LoaderService } from './services/loaderService.service';
import { AuthService } from './services/auth.service';
@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  private queue: ReplaySubject<any>[] = [];

  constructor(
    public loadingController: LoaderService,
    private authService: AuthService
  ) { }

  get accessToken() {
    return this.authService.accessToken;
  }

  set accessToken(val: string | null) {
    this.authService.accessToken = val;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add the new header
    const isBase = request.url.includes(environment.apiAddress);
    const isClientSide = request.url.includes('setClientSideMetadata');
    if (this.accessToken != null && isBase) {
      const requestQueueItem$ = new ReplaySubject<any>();
      const clonedRequest = request.clone({
        headers: request.headers
          .set('Authorization', 'Bearer ' + this.accessToken)
      });
      if (isClientSide) {
        const result$ = requestQueueItem$.pipe(
          switchMap(() => next.handle(clonedRequest).pipe(
            tap(req => {
              if (req.type === HttpEventType.Response) {
                this.processNextRequest();
              }
            }),
            catchError(err => {
              this.processNextRequest();
              throw err;
            })
          ))
        );
        this.queue.push(requestQueueItem$);

        if (this.queue.length <= 1) {
          this.dispatchRequest();
        }

        return result$;
      }
      return next.handle(clonedRequest).pipe(
        tap(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              // do stuff with response if you want
            }
          },
          (err: any) => {
            this.loadingController.hideLoader();
            if (err instanceof HttpErrorResponse) {
              // do stuff with response if you want
            };
          }));
    } else {
      return next.handle(request).pipe(
        tap(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              // do stuff with response if you want
            }
          },
          (err: any) => {
            this.loadingController.hideLoader();
            if (err instanceof HttpErrorResponse) {
              // do stuff with response if you want
            };
          }));
    }
  }

  private processNextRequest(): void {
    if (this.queue && this.queue.length > 0) {
      this.queue.shift();
    }
    this.dispatchRequest();
  }

  private dispatchRequest(): void {
    if (this.queue.length > 0) {
      const nextSub$ = this.queue[0];
      nextSub$.next(null);
      nextSub$.complete();
    }
  }
}
